import React from 'react';

export default function RevenueReportingPeriod(props) {
	return (
		<div className="PropertyNavigationTabs mt-8">
			<span className="text-gray-800 mr-2">Reporting Period:</span>
			<span className="text-gray-800 mx-1">2/1/2023</span>-
			<span className="text-gray-800 mx-1">2/28/2023</span>
		</div>
	);
}
